<template>
    <div class="main-check-work">
        <div class="check-work">
            <div class="card-item">
                <div class="title">
                    <span>文件基础信息</span>
                </div>
                <el-row>
                    <el-col :span="12">
                        <div class="desc">
                            <label class="desc-name">证书编号：</label>
                            <label class="desc-value">{{works.copyrightRegisterAuthCertNo}}</label>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="desc">
                            <label class="desc-name">文件名称：</label>
                            <label class="desc-value">{{works.worksName}}</label>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="desc">
                            <label class="desc-name">作品类别：</label>
                            <label class="desc-value">{{loadWorksType(works.copyrightRegisterAuthDTO.worksType)}}</label>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="desc">
                            <label class="desc-name">创作/制作完成日期：</label>
                            <label class="desc-value">{{works.copyrightRegisterAuthDTO.completeDate}}</label>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="desc">
                            <label class="desc-name">认证日期：</label>
                            <label class="desc-value">{{works.createTime}}</label>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="desc" v-if="works.copyrightRegisterAuthDTO.authors && works.copyrightRegisterAuthDTO.authors.length > 0">
                            <label class="desc-name">作者姓名：</label>
                            <label class="desc-value">{{buildAuthorName(works.copyrightRegisterAuthDTO.authors)}}</label>
                        </div>
                    </el-col>
                </el-row>
                
            </div>
            <div class="card-item" style="margin-top: 30px;">
                <div class="title">
                    <span>文件权利信息</span>
                </div>
                <div class="constant-main">
                    <div class="desc" v-if="works.copyrightRegisterAuthDTO.copyrightOwners && works.copyrightRegisterAuthDTO.copyrightOwners.length > 0">
                        <label class="desc-name">著作权人：</label>
                        <label class="desc-value">{{buildAuthorName(works.copyrightRegisterAuthDTO.copyrightOwners)}}</label>
                    </div>
                    <div class="desc">
                        <label class="desc-name">作品创作性质：</label>
                        <label class="desc-value">{{loadWorkCreateNature(works.copyrightRegisterAuthDTO.createNature)}}</label>
                    </div>
                    <div class="desc">
                        <label class="desc-name">权利获得方式：</label>
                        <label class="desc-value">
                            <span v-if="works.copyrightRegisterAuthDTO.rightGainType != 4">{{loadrightGainType(works.copyrightRegisterAuthDTO.rightGainType)}}</span>
                            <span v-else>{{works.copyrightRegisterAuthDTO.rightGainTypeType == 1?'转让':'许可使用'}}</span>
                        </label>
                    </div>
                    <div class="desc">
                        <label class="desc-name">权利归属方式：</label>
                        <label class="desc-value">{{loadRightAttributionType(works.copyrightRegisterAuthDTO.rightAscriptionType)}}</label>
                    </div>
                    <div class="desc">
                        <label class="desc-name">权利拥有状况：</label>
                        <label class="desc-value">
                            {{ loadRightHaveLabel(works.copyrightRegisterAuthDTO.rightHaves) }}
                        </label>
                    </div>
                    <div class="desc">
                        <label class="desc-name">证书唯一标识：</label>
                        <label class="desc-value" style="max-width: 430px;display: inline-block;word-wrap: break-word;">
                            {{works.copyrightRegisterHash}}
                        </label>
                    </div>
                    <div class="desc" v-if="works.copyrightRegisterAuthDTO.rightGainType == 4 && works.copyrightRegisterAuthDTO.rightGainTypeType == 1">
                        <label class="desc-name">受让方：</label>
                        <label class="desc-value">
                            {{ works.copyrightRegisterAuthDTO.licensees && works.copyrightRegisterAuthDTO.licensees.length>0? works.copyrightRegisterAuthDTO.licensees[0].obligeeName:'无' }}
                        </label>
                    </div>
                    <div class="desc" v-if="works.copyrightRegisterAuthDTO.rightGainType == 4 && works.copyrightRegisterAuthDTO.rightGainTypeType == 2">
                        <label class="desc-name">被许可方：</label>
                        <label class="desc-value">
                            {{ works.copyrightRegisterAuthDTO.licensees && works.copyrightRegisterAuthDTO.licensees.length>0? works.copyrightRegisterAuthDTO.licensees[0].obligeeName:'无' }}
                        </label>
                    </div>
                    
                    <div class="desc" v-if="works.copyrightRegisterAuthDTO.rightGainType == 4 && works.copyrightRegisterAuthDTO.rightGainTypeType == 1">
                        <label class="desc-name">转让方：</label>
                        <label class="desc-value">
                            {{ works.copyrightRegisterAuthDTO.licensors && works.copyrightRegisterAuthDTO.licensors.length>0? 
                            (works.copyrightRegisterAuthDTO.licensors.map(item=>{return item.obligeeName}).join(',')):'无' }}
                        </label>
                    </div>
                    <div class="desc" v-if="works.copyrightRegisterAuthDTO.rightGainType == 4 && works.copyrightRegisterAuthDTO.rightGainTypeType == 2">
                        <label class="desc-name">许可方：</label>
                        <label class="desc-value">
                            {{ works.copyrightRegisterAuthDTO.licensors && works.copyrightRegisterAuthDTO.licensors.length>0? 
                            (works.copyrightRegisterAuthDTO.licensors.map(item=>{return item.obligeeName}).join(',')):'无' }}
                        </label>
                    </div>
                    <div class="desc" v-if="works.copyrightRegisterAuthDTO.rightGainType == 4 
                        && works.copyrightRegisterAuthDTO.rightGainTypeType == 2 
                        && works.copyrightRegisterAuthDTO.rightLicenseUseType">
                        <label class="desc-name">许可使用权利：</label>
                        <label class="desc-value">
                            {{ works.copyrightRegisterAuthDTO.rightLicenseUseType == 1 ?'专有许可使用':'非专有许可使用'}}
                        </label>
                    </div>
                    <div class="desc" v-if="works.copyrightRegisterAuthDTO.rightGainType == 4 
                        && works.copyrightRegisterAuthDTO.rightGainTypeDate">
                        <label class="desc-name">权利获得日期：</label>
                        <label class="desc-value">
                            {{ works.copyrightRegisterAuthDTO.rightGainTypeDate }}
                        </label>
                    </div>
                    <div class="desc" v-if="works.copyrightRegisterAuthDTO.rightGainType == 4 
                        && works.copyrightRegisterAuthDTO.rightLicenseStartDate
                        && works.copyrightRegisterAuthDTO.rightLicenseEndDate">
                        <label class="desc-name">许可期限：</label>
                        <label class="desc-value">
                            {{ works.copyrightRegisterAuthDTO.rightLicenseStartDate +'至'+ works.copyrightRegisterAuthDTO.rightLicenseEndDate }}
                        </label>
                    </div>
                    <div class="desc" v-if="works.copyrightRegisterAuthDTO.rightGainType == 4 
                        && works.copyrightRegisterAuthDTO.rightGainTypeType == 2 
                        && works.copyrightRegisterAuthDTO.licenseArea">
                        <label class="desc-name">地域范围：</label>
                        <label class="desc-value">
                            {{ works.copyrightRegisterAuthDTO.licenseArea }}
                        </label>
                    </div>
                </div>
                <!-- <el-row>
                    <el-col :span="12">
                        <div class="desc">
                            <label class="desc-name">著作权人：</label>
                            <label class="desc-value">{{buildAuthorName(works.copyrightRegisterAuthDTO.copyrightOwners)}}</label>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="desc">
                            <label class="desc-name">作品创作性质：</label>
                            <label class="desc-value">{{loadWorkCreateNature(works.copyrightRegisterAuthDTO.createNature)}}</label>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="desc">
                            <label class="desc-name">权利获得方式：</label>
                            <label class="desc-value">{{loadrightGainType(works.copyrightRegisterAuthDTO.rightGainType)}}</label>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="desc">
                            <label class="desc-name">权利归属方式：</label>
                            <label class="desc-value">{{loadRightAttributionType(works.copyrightRegisterAuthDTO.rightAscriptionType)}}</label>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="desc">
                            <label class="desc-name">权利拥有状况：</label>
                            <label class="desc-value">
                                {{ loadRightHaveLabel(works.copyrightRegisterAuthDTO.rightHaves) }}
                            </label>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="desc">
                            <label class="desc-name">证书唯一标识：</label>
                            <label class="desc-value" style="max-width: 430px;display: inline-block;word-wrap: break-word;">
                                {{works.copyrightRegisterHash}}
                            </label>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="desc">
                            <label class="desc-name">被许可方/受让方：</label>
                            <label class="desc-value">
                            </label>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="desc">
                            <label class="desc-name">许可方/转让方：</label>
                            <label class="desc-value">
                            </label>
                        </div>
                    </el-col>
                </el-row> -->
            </div>
            <div class="card-item" style="margin-top: 30px;padding-bottom: 0;">
                <div class="title" style="justify-content: center;align-items: center;display: flex;">
                    <img src="@/assets/images/effective.png" width="39px"/>
                    <img src="@/assets/images/protect.png"/>
                </div>
                
            </div>
            <div class="card-item" style="margin-top: 30px;">
                <div class="title" >
                    <span>证书文件</span>
                </div>
                <div style="padding: 0 20px;">
                    <img
                        :src="'resrun-paas/file/downloadFileStream/'+works.certImageId"
                        alt=""
                        width="800px"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { checkWork } from '@/api/business'
    import router from '@/router';
     export default {
        name:'check-work-error',
        components:{
        },
        data () {
            return { 
                activeName:1, 
                certNo:"",
                fileHash:"",
                works:{},
                rightHavesOptions:[
                { label: '发表权', value: 1 },
                { label: '署名权', value: 2 },
                { label: '修改权', value: 3 },
                { label: '保护作品完整权', value: 4 },
                { label: '复制权', value: 5 },
                { label: '发行权', value: 6 },
                { label: '出租权', value: 7 },
                { label: ' 展览权', value: 8 },
                { label: '表演权', value: 9 },
                { label: '放映权', value: 10 },
                { label: '广播权', value: 11 },
                { label: '信息网络传播权', value: 12 },
                { label: '摄制权', value: 13 },
                { label: '改编权', value: 14 },
                { label: ' 翻译权', value: 15 },
                { label: '汇编权', value: 16 },
                { label: '其他', value: 17 },
            ]
            }
        },
        mounted() {
            this.certNo = router.currentRoute.query.certNo;
            this.fileHash = router.currentRoute.query.fileHash;
           this.init()
        },
        methods: {
             init(){
                checkWork({copyrightRegisterAuthCertNo:this.certNo,copyrightRegisterHash:this.fileHash}).then(res=>{
                    if(res.code == 200){
                        this.works = res.result;
                    }
                })
            },
            buildAuthorName(list){
                var name = ""
                list.forEach(item=>{
                    name += item.obligeeName+',';
                })
                return name.slice(0,name.length-1);
            },
            loadWorksType(status) {
                switch (status) {
                    case '1':
                    return '文字作品';
                    case '2':
                    return '口述作品';
                    case '3':
                    return '音乐作品';
                    case '4':
                    return '戏剧作品';
                    case '5':
                    return '曲艺作品';
                    case '6':
                    return '舞蹈作品';
                    case '7':
                    return '杂技作品';
                    case '8':
                    return '美术作品';
                    case '9':
                    return '建筑作品';
                    case '10':
                    return '摄影作品';
                    case '11':
                    return '视听作品';
                    case '12':
                    return '工程设计图、产品设计图';
                    case '13':
                    return '地图、示意图';
                    case '14':
                    return '模型';
                    case '15':
                    return '其他作品';
                    default:
                    return '';
                }
            },
            loadWorkCreateNature(type) {
                switch (type) {
                    case '1':
                    return '原创';
                    case '2':
                    return '改编';
                    case '3':
                    return '翻译';
                    case '4':
                    return '汇编';
                    case '5':
                    return '注释';
                    case '6':
                    return '整理';
                    case '7':
                    return '其他';
                    default:
                    return '';
                }
            },
            loadrightGainType(type) {
                switch (type) {
                    case '1':
                    return '原始';
                    case '2':
                    return '继承';
                    case '3':
                    return '承受';
                    case '4':
                    return '其他';
                    default:
                    return '';
                }
            },
            loadRightAttributionType(type) {
                switch (type) {
                    case '1':
                    return '个人作品';
                    case '2':
                    return '合作作品';
                    case '3':
                    return '法人作品';
                    case '4':
                    return '职务作品';
                    case '5':
                    return '委托作品';
                    default:
                    return '';
                }
            },
            loadRightHaveType(type) {
                switch (type) {
                    case '0':
                    return '手动选择';
                    case '1':
                    return '全部17项';
                    case '2':
                    return '全部16项';
                    case '3':
                    return '全部13项';
                    case '4':
                    return '职务作品';
                    default:
                    return '';
                }
            },
            loadRightHaveLabel(keys) {
                let labels = [];
                keys &&
                keys.map((key) => {
                    let matchLabel = this.rightHavesOptions.filter((v) => v.value == key);
                    if (matchLabel) {
                    labels.push(matchLabel[0].label);
                    }
                });
                return labels.join('、');
            }
        }
     }
</script>

<style lang="less" scoped>
.main-check-work{
    margin-top: 68px;
    text-align: left;
    .check-work{
        width: 1200px;
        margin: 0 auto;
        padding: 30px 0;
        .card-item{
            background-color: #F7F9FC;
            padding: 0 0px 20px;
            .title{
                padding: 15px 20px;
                font-size: 16px;
                font-weight: 400;
                position: relative;
            }
            .title::after{
                content: "";
                position: absolute;
                height: 15px;
                width: 2px;
                background-color: #206BD1;
                left: 0;
                top: 18px;

            }
            .desc{
                display: flex;
                font-size: 14px;
                padding: 0 20px;
                color: #666666;
                
                .desc-name{
                    line-height: 30px;
                    // min-width: 100px;
                }
                .desc-value{
                    flex: 1;
                    line-height: 30px;
                    margin-left: 5px; 
                }
            }
        }
    }
}
.constant-main{
    display: flex;
    flex-wrap: wrap;
    .desc{
        width: 600px;
        box-sizing: border-box;
    }
}
    
</style>